:host {
  display: list-item;
  font-size: wink-rem(1.8);
  line-height: wink-rem(2.8);
  list-style: none;

  @include media('until-md') {
    padding: var-rem(--semantic-spacing-xs) 0;
  }

  .navigation-list-item {
    font-family: var(--wink-navigation-list-font-family, inherit);
    font-weight: var(--wink-navigation-list-font-weight, 400);
    color: var(--semantic-color-text-default);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      text-decoration-thickness: var-rem(--wink-navigation-list-underline-thickness, --semantic-border-md);
      text-underline-offset: var-rem(--semantic-spacing-3xs);
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      @include state-focus-outline;

      margin-left: var-rem(--semantic-spacing-2xs);

      @include media-header('from-md') {
        margin-left: var-rem(--semantic-spacing-3xs);
      }
    }
  }
}
